
// import React, { useEffect, useState } from 'react';
// import { collection,onSnapshot } from 'firebase/firestore';
// import { db } from '../firebase';
// import { Helmet } from 'react-helmet';
// import Navbar from '../components/Navbar';
// import HeroSection from '../components/HeroSection';
// import JobsListing from '../components/LatestJobs';
// import JobCategories from '../components/JobCategories';
// import Footer from '../components/Footer';
// import WhatsAppCommunity from '../components/WhatsappCommunity';
// import HowItWorks from '../components/HowItWorks'
// import SEO from '../components/SEO';
// import TestimonialSection from '../components/Testimonials';


// function Home() {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [locationFilter, setLocationFilter] = useState('');
//   const [jobs, setJobs] = useState([]);

//   const categories = [
//     "Technology", "Marketing", "Design", "Finance", "Sales",
//     "Human Resources", "Operations", "Customer Service",
//     "Healthcare", "Education",
//   ];

//   useEffect(() => {
//   const unsubscribe = onSnapshot(collection(db, "jobs"), (snapshot) => {
//     const jobsList = snapshot.docs.map(doc => ({
//       id: doc.id,
//       ...doc.data()
//     }));
//     setJobs(jobsList);
//   }, (error) => {
//     console.error("Real-time error fetching jobs:", error.message);
//   });

//   // Cleanup on unmount
//   return () => unsubscribe();
// }, []);


//   const now = new Date();

//   const jobsInLast15Days = jobs.filter((job) => {
//     const diffInDays = (now - job.postedDate) / (1000 * 60 * 60 * 24);
//     return diffInDays <= 15;
//   });

//   const sortedJobs = [...jobs].sort(
//     (a, b) => new Date(b.postedDate) - new Date(a.postedDate)
//   );

//   const latestJobs = sortedJobs.slice(0, 12);

//   const filteredLatestJobs = latestJobs.filter((job) => {
//     const matchesSearch =
//       job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       job.company.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesLocation =
//       locationFilter === "" || job.location === locationFilter;

//     return matchesSearch && matchesLocation;
//   });

//   return (
//     <>
//     <Helmet>
//   <script type="application/ld+json">
//     {JSON.stringify({
//       "@context": "https://schema.org",
//       "@type": "WebSite",
//       "name": "Jobs in Delhi NCR",
//       "url": "https://jobsindelhincr.in",
//       "potentialAction": {
//         "@type": "SearchAction",
//         "target": "https://jobsindelhincr.in/findjobs?search={search_term_string}",
//         "query-input": "required name=search_term_string"
//       }
//     })}
//   </script>

//   <script type="application/ld+json">
//     {JSON.stringify({
//       "@context": "https://schema.org",
//       "@type": "Organization",
//       "name": "Jobs in Delhi NCR",
//       "url": "https://jobsindelhincr.in",
//       "logo": "https://jobsindelhincr.in/logo.png", // Replace with your real logo URL
//       "sameAs": [
//         // "https://www.linkedin.com/company/your-company",
//         "https://www.facebook.com/jobsindelhincr"
//       ]
//     })}
//   </script>
// </Helmet>
//     <SEO
//         title="Jobs in Delhi NCR | Tech, Marketing, Finance"
//         description="Browse thousands of job opportunities in Delhi NCR. Updated daily. Apply now for tech, marketing, and finance jobs."
//       />
//       <Navbar />
//       <HeroSection
//         searchTerm={searchTerm}
//         setSearchTerm={setSearchTerm}
//         locationFilter={locationFilter}
//         setLocationFilter={setLocationFilter}
//       />
//       <JobsListing filteredJobs={filteredLatestJobs} />
//       <WhatsAppCommunity />
//       <JobCategories categories={categories} jobs={jobsInLast15Days} />
//       <HowItWorks></HowItWorks>
//       <TestimonialSection/>
//       <Footer />
//     </>
//   );
// }

// export default Home;








import React, { useEffect, useState } from 'react';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import JobsListing from '../components/LatestJobs';
import JobCategories from '../components/JobCategories';
import Footer from '../components/Footer';
import WhatsAppCommunity from '../components/WhatsappCommunity';
import HowItWorks from '../components/HowItWorks';
import SEO from '../components/SEO';
import TestimonialSection from '../components/Testimonials';

function Home() {
  const [searchTerm, setSearchTerm] = useState('');
  const [locationFilter, setLocationFilter] = useState('');
  const [jobs, setJobs] = useState([]);

  const categories = [
    "Technology", "Marketing", "Design", "Finance", "Sales",
    "Human Resources", "Operations", "Customer Service",
    "Healthcare", "Education",
  ];

  const parseFirebaseDate = (value) => {
    if (!value) return null;
    if (typeof value.toDate === 'function') {
      try { return value.toDate(); } catch { /* fallthrough */ }
    }
    if (value.seconds && typeof value.seconds === 'number') {
      return new Date(value.seconds * 1000);
    }
    if (typeof value === 'string') {
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d;
    }
    if (value instanceof Date) return value;
    return null;
  };

  useEffect(() => {
    const q = query(collection(db, "jobs"), orderBy("postedDate", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const jobsList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setJobs(jobsList);
    }, (error) => {
      console.error("Real-time error fetching jobs:", error.message);
    });

    return () => unsubscribe();
  }, []);

  const now = new Date();

  // Jobs posted in last 15 days (handles Timestamp / ISO string / Date)
  const jobsInLast15Days = jobs.filter((job) => {
    const pd = parseFirebaseDate(job.postedDate);
    if (!pd) return false;
    const diffInDays = (now - pd) / (1000 * 60 * 60 * 24);
    return diffInDays <= 15;
  });

  const sortedJobs = [...jobs].sort((a, b) => {
    const da = parseFirebaseDate(a.postedDate) || new Date(0);
    const db = parseFirebaseDate(b.postedDate) || new Date(0);
    return db - da; // newest first
  });

  const latestJobs = sortedJobs.slice(0, 12);

  const s = searchTerm.trim().toLowerCase();
  const loc = locationFilter.trim().toLowerCase();

  const filteredLatestJobs = latestJobs.filter((job) => {
    const title = (job.title || '').toString().toLowerCase();
    const company = (job.company || '').toString().toLowerCase();
    const jobLocation = (job.location || '').toString().toLowerCase();

    const matchesSearch = !s || title.includes(s) || company.includes(s);
    const matchesLocation = !loc || jobLocation.includes(loc);

    return matchesSearch && matchesLocation;
  });

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Jobs in Delhi NCR",
            "url": "https://jobsindelhincr.in",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://jobsindelhincr.in/findjobs?search={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Jobs in Delhi NCR",
            "url": "https://jobsindelhincr.in",
            "logo": "https://jobsindelhincr.in/logo.png",
            "sameAs": [
              "https://www.facebook.com/jobsindelhincr"
            ]
          })}
        </script>
      </Helmet>

      <SEO
        title="Jobs in Delhi NCR | Tech, Marketing, Finance"
        description="Browse thousands of job opportunities in Delhi NCR. Updated daily. Apply now for tech, marketing, and finance jobs."
      />
      <Navbar />
      <HeroSection
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        locationFilter={locationFilter}
        setLocationFilter={setLocationFilter}
      />
      <JobsListing filteredJobs={filteredLatestJobs} />
      <WhatsAppCommunity />
      <JobCategories categories={categories} jobs={jobsInLast15Days} />
      <HowItWorks />
      <TestimonialSection />
      <Footer />
    </>
  );
}

export default Home;
